export const formatVerify = (value: string) => {
  const clear = value.replace(/\D/g, '');

  return clear.replace(/^(\d{1,4}).*/, '$1');
};
